import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { RECURRENCE_EXCEPTION_TYPES, RECURRENCE_VARIANTS } from "./constants";

const flag = z
  .string()
  .optional()
  .transform((value) => value !== undefined && value !== "false");

const exception = z.object({
  id: z.number().nullish(),
  type: z.enum(RECURRENCE_EXCEPTION_TYPES),
  start: z.string().nullish(),
  stop: z.string().nullish(),
  nbWeeks: z.number().nullish(),
});

export const dateRecurrencePickerDataSchema = z.object({
  value: z.string().optional(),
  locale: z.string().optional(),
  variant: z
    .enum(RECURRENCE_VARIANTS)
    .optional()
    .describe(
      'Trigger chrome: "link" drops the box, for a picker that sits in a sentence or a toolbar rather than in a form.',
    ),
  size: z.enum(SIZES).optional(),
  placeholder: z.string().optional(),
  disabled: flag,
  showEnd: flag,
  tour: z
    .string()
    .optional()
    .transform((value) => value === undefined || value !== "false"),
  exceptions: z
    .string()
    .optional()
    .transform((value) => {
      if (!value) {
        return [];
      }

      try {
        return z.array(exception).parse(JSON.parse(value));
      } catch {
        return [];
      }
    }),
  exceptionsName: z.string().optional(),
});

export type DateRecurrencePickerDataProps = z.infer<
  typeof dateRecurrencePickerDataSchema
>;
